export const _newsArticleClass = {
  title: { type: 'string', title: 'Otsikko' },
  excerpt: {
    type: 'string',
    title: 'Lyhyt kuvaus',
    description: 'Lyhyt tiivistelmä artikkelista'
  },
  tags: {
    type: 'string',
    title: 'Tagit',
    description: 'Pilkulla erotetut tagit (esim. urhelu, tapahtumat)'
  },
  showOnUserUI: {
    type: 'boolean',
    title: 'Näytä asiakaskäyttöliittymässä',
    description: 'Jos ei valittu, artikkeli on saatavilla vain suoran linkin kautta'
  },
  publishDate: {
    type: 'string',
    format: 'date',
    title: 'Julkaisupäivä',
    description: 'Ajastettu julkaisupäivä'
  },
}

export const _newsUISchema = {
  excerpt: {
    'ui:widget': 'textarea',
    'ui:options': {
      rows: 3
    }
  },
}

export const NEWS_STATE_TRANSLATIONS = {
  draft: 'Luonnos',
  scheduled: 'Ajastettu',
  published: 'Julkaistu',
  deleted: 'Poistettu',
}

export const NEWS_STATE_COLORS = {
  draft: 'secondary',
  scheduled: 'info',
  published: 'success',
  deleted: 'danger',
}
